// recompose dependency removed as the library is no longer maintained and has vulnerabilities
// extracted a few hoc functions in this file

/*
    createFactory from react is deprecated and will be removed in next major release of react
    Below is an alternative for createFactory
    visit - https://react.dev/reference/react/createFactory#alternatives
 */

import { createElement } from "react";

function createFactory(type) {
  return createElement.bind(null, type);
}

/* 
    compose function from recompose pkg
    visit - https://github.com/acdlite/recompose/blob/master/src/packages/recompose/compose.js 
*/
const compose = (...funcs) =>
  funcs.reduce(
    (a, b) => (...args) => a(b(...args)),
    arg => arg
  );

/* 
    branch function from recompose pkg
    visit - https://github.com/acdlite/recompose/blob/master/src/packages/recompose/branch.js
*/

const setStatic = (key, value) => BaseComponent => {
  /* eslint-disable no-param-reassign */
  BaseComponent[key] = value;
  /* eslint-enable no-param-reassign */
  return BaseComponent;
};

const setDisplayName = displayName => setStatic("displayName", displayName);

const wrapDisplayName = (BaseComponent, hocName) =>
  `${hocName}(${getDisplayName(BaseComponent)})`;

const getDisplayName = Component => {
  if (typeof Component === "string") {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || "Component";
};

const identity = Component => Component;

const branch = (test, left, right = identity) => BaseComponent => {
  let leftFactory;
  let rightFactory;
  const Branch = props => {
    if (test(props)) {
      leftFactory = leftFactory || createFactory(left(BaseComponent));
      return leftFactory(props);
    }
    rightFactory = rightFactory || createFactory(right(BaseComponent));
    return rightFactory(props);
  };

  if (process.env.NODE_ENV !== "production") {
    return setDisplayName(wrapDisplayName(BaseComponent, "branch"))(Branch);
  }
  return Branch;
};

export { compose, branch };
